import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import VATDefinitionForm from 'Services/ProductManagement/Features/VATDefinition/Components/VATDefinitionForm'
import { SELECTED_VAT_DEFINITION_PARAMETER_KEY } from 'Services/ProductManagement/Features/VATDefinition/Hooks/useVATDefinitionsWithParams'
import { useGetSingleVatDefinitionQuery } from 'Services/ProductManagement/Features/VATDefinition/vatDefinitionApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function VATDefinitionEditPage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/settings/vat-definitions`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_VAT_DEFINITION_PARAMETER_KEY}=${id}`
  )
  const { data: singleVatDefinition, isFetching } = useGetSingleVatDefinitionQuery(id ?? '', {
    skip: !id
  })

  const breadcrumbs = [
    {
      title: t`Settings`
    },
    {
      title: t`VAT definitions`,
      link: baseUrl
    },
    {
      title: singleVatDefinition ? singleVatDefinition.title : ''
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit VAT definition`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isFetching}>
        {singleVatDefinition && (
          <VATDefinitionForm
            vatDefinition={singleVatDefinition}
            successBaseUrl={previousLocation}
          />
        )}
      </WithLoader>
    </Box>
  )
}
